import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDate } from "../../shared/JVDate";
import { IBranchMastDropdown, IClientCompanyDropdown, ICompanyMastDropdown, IECIStatusDropdown, ISkillCategoriesDropdown, ITeamsDropdown, IUsersDropdown } from "../../models/IDropdown";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { ILogin } from "../../models/Login";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { client_Type } from "../../models/FDropdown";


export interface IECIFilter {
    fromDate?: Date | null,
    toDate?: Date | null,
    subVendor?: string | null,
    req_ID?: number | null | string,
    req_PostedBySalesManager?: number | null,
    req_SubmittedByRecruiter?: number | null,
    team?: number | null,
    company?: string | null,
    branch_Sales?: number[] | null,
    branch_Recruiter?: number[] | null,
    ECI_Type_Name?: string | null,
    req_Category?: number | null,
    user_Status?: boolean | null,
    s_User_Status?: boolean | null,
    r_User_Status?: boolean | null,
    Consultant_Name?: string | null,
    vendor_Company_ID?: number,
    vendor_Company_Name?: string,
    vendor_Company?: IClientCompanyDropdown,

}
export const EmptyFilter: IECIFilter = {
    fromDate: new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)),
    toDate: new Date,
    subVendor: "",
    req_ID: "",
    req_PostedBySalesManager: null,
    req_SubmittedByRecruiter: null,
    team: null,
    company: null,
    branch_Sales: null,
    branch_Recruiter: null,
    ECI_Type_Name: "",
    req_Category: null,
    s_User_Status: null,
    r_User_Status: null,
    Consultant_Name: ""
}

interface Iprops {
    // open: boolean,
    // hideDialog: () => void,
    // toast: any,
    filters: IECIFilter,
    setFilters: (filters: IECIFilter) => void,
}

export const Filter = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [sales, setSales] = useState<Array<IUsersDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [team, setTeam] = useState<Array<ITeamsDropdown>>();
    const [ecIStatus, setEciStatus] = useState<IECIStatusDropdown[]>();
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();
    const [selectedSm, setselectedSm] = useState<any | null>(null);
    const [selectedRecruiter, setSelectedRecruiter] = useState<any | null>(null);
    const [selectedCompany, setSelectedCompany] = useState<Array<number>>([]);
    const [selectedBranch, setSelectedBranch] = useState<Array<number>>([]);
    const [selectedSBranch, setSelectedSBranch] = useState<Array<number>>([]);
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();


    const { control, handleSubmit, reset, watch } = useForm<IECIFilter>({
        defaultValues: props.filters,
        shouldFocusError: false
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });


    const sales_Status = [
        { label: "-- SELECT --", status: null },
        { label: 'Active', status: true },
        { label: 'Inactive', status: false },
    ]
    const recruiters_Status = [
        { label: "-- SELECT --", status: null },
        { label: 'Active', status: true },
        { label: 'Inactive', status: false },
    ]

    const LitencyType = [
        { litency_Type: '0-45' },
        { litency_Type: '46-90' },
        { litency_Type: '91-120' },
        { litency_Type: '120+' },
    ]

    const loadBranches = async (company: number[] | null) => {
        let queryParam = company !== null && company.length >= 1 ? `company_id=${company.join(",")}` : null;

        const response = await Fetch("Dropdown/multiCompbranches", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }
    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/company", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }
    const loadSales = async (branch: number[] | null | undefined, company: number[] | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            //queryParameter = `branch_ID=${branch}`;
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");

        } else if (company && company.length > 0) {
            queryParameter = `company_ID=${company.join(",")}`;
        } else if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        }
        const response = await Fetch("Dropdown/multiSelectSalesManagerListBranch", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSales(data);
        }
    }
    const loadTeam = async (branch: number[] | null | undefined, company: number[] | null | undefined, type?: string) => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            queryParameter = `branch_ID=${branch.join(",")}`;
            // queryParameter = branch.map(b => `branch_ID=${b}`).join("&");

        } else if (company && company.length > 0) {
            queryParameter = `company_ID=${company.join(",")}`;
        }
        if (type && type != "" && type != "-- SELECT --") {
            if (type === "sales") queryParameter = "user_Type=sales&" + queryParameter;
            if (type === "recruiter") queryParameter = "user_Type=recruiter&" + queryParameter;
        }
        const response = await Fetch("Dropdown/multiSeectFilterTeamsList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const emptyData = {
                team_ID: 0,
                team_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setTeam(data);
        }
    }
    const loadRecruiters = async (branch: number[] | null | undefined, company: number[] | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (branch && branch.length > 0 && branch[0] != 0) {
            // queryParameter = `branch_ID=${branch}`;
            queryParameter = branch.map(b => `branch_ID=${b}`).join("&");
        } else if (company && company.length > 0) {
            queryParameter = `company_ID=${company.join(",")}`;
        } else if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        }
        const response = await Fetch("Dropdown/multiSelectSalesManagerListBranch", "GET", null, `user_Type=recruiter&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecruiters(data);
        }
    }

    const loadStatus = async () => {
        const response = await Fetch("Dropdown/ecI_status", "GET", null, null, null);
        if (response) {
            const data: Array<IECIStatusDropdown> = await response.json();
            // console.log(data);
            const emptyData = {
                ecI_Type_ID: 0,
                ecI_Type_Name: "-- SELECT --"
            };
            data.unshift(emptyData);

            setEciStatus(data);
        }
    };

    const loadSkillCategories = async () => {
        const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            const emptyData = {
                req_CategoryID: 0,
                req_CategoryName: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSkillCategories(data);
        }
    }

    useEffect(() => {
        loadCompanies();
        loadBranches([]);
        loadSales([], [], 0);
        loadTeam([], []);
        loadRecruiters([], [], 0);
        loadStatus();
        loadSkillCategories();
    }, []);

    const searchToDB = async (body: IECIFilter) => {
        // onHide();
        body.req_PostedBySalesManager = selectedSm;


        body.req_SubmittedByRecruiter = selectedRecruiter
        if (selectedSBranch.length > 0) {
            body.branch_Sales = selectedSBranch;
        }
        if (selectedBranch.length > 0) {
            body.branch_Recruiter = selectedBranch;
        }
        props.setFilters(body);
        console.log(body.toDate)
    }

    function onSubmit(data: IECIFilter) {
        // data.branch_Sales = selectedSBranch;
        // data.branch_Recruiter = selectedBranch;
        if (data.vendor_Company?.vendor_Company_ID) data.vendor_Company_ID = data.vendor_Company?.vendor_Company_ID;
        delete data.vendor_Company;
        data.company = selectedCompany.length > 0 ? selectedCompany.join(',') : null;
        searchToDB(data);
        //    const localDob = new Date(data.toDate.getTime() - data.toDate.getTimezoneOffset() * 60000);

    }
    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            // if (name === "company") {
            //     if (value.company != "0") {
            //         // loadBranches(value.company);
            //         // loadSales([], value.company, 0);
            //         // loadRecruiters([], value.company, 0);
            //         // loadTeam([], value.company);
            //     } else {
            //         // loadBranches();
            //         loadTeam([], 0);
            //         if (control._formValues.branch != 0) {
            //             loadTeam(control._formValues.branch, 0);
            //         } else if (control._formValues.branch == 0) {
            //             loadTeam([], 0);
            //         }

            //         if (control._formValues.branch != 0 && control._formValues.team != 0) {
            //             loadRecruiters([], 0, control._formValues.team);
            //         } else if (control._formValues.branch == 0 && control._formValues.team != 0) {
            //             loadRecruiters([], 0, control._formValues.team);
            //         } else if (control._formValues.branch != 0 && control._formValues.team == 0) {
            //             loadRecruiters(control._formValues.branch, 0, 0);
            //         } else if (control._formValues.branch == 0 && control._formValues.team == 0) {
            //             loadRecruiters([], 0, 0);
            //         }
            //     }
            // }

            // if (name === "branch_Sales") {
            //     if (selectedBranch.length > 0) {
            //         // loadSales(value.branch_Sales, 0, 0);
            //         //loadTeam(value.branch_Sales, 0);
            //     } else {
            //         if (control._formValues.company != 0) {
            //             loadTeam([], control._formValues.company);
            //         } else if (control._formValues.company == 0) {
            //             loadTeam([], 0);
            //         }

            //         if (control._formValues.company != 0 && control._formValues.team != 0) {
            //             loadSales([], 0, control._formValues.team);
            //         } else if (control._formValues.company == 0 && control._formValues.team != 0) {
            //             loadSales([], 0, control._formValues.team);
            //         } else if (control._formValues.company != 0 && control._formValues.team == 0) {
            //             loadSales([], control._formValues.company, 0);
            //         } else if (control._formValues.company == 0 && control._formValues.team == 0) {
            //             loadSales([], 0, 0);
            //         }
            //     }
            // }

            // if (name === "branch_Recruiter") {
            //     if (selectedBranch.length > 0) {
            //         loadRecruiters(selectedBranch, 0, 0);
            //         loadTeam(selectedBranch, 0); // Assuming loadTeam takes a single branch

            //         //loadRecruiters(value[0].branch_Recruiter, 0, 0);
            //         //loadTeam(value.branch_Recruiter, 0);
            //     } else {
            //         if (control._formValues.company != 0) {
            //             loadTeam([], control._formValues.company);
            //         } else if (control._formValues.company == 0) {
            //             loadTeam([], 0);
            //         }

            //         if (control._formValues.company != 0 && control._formValues.team != 0) {
            //             loadRecruiters([], 0, control._formValues.team);
            //         } else if (control._formValues.company == 0 && control._formValues.team != 0) {
            //             loadRecruiters([], 0, control._formValues.team);
            //         } else if (control._formValues.company != 0 && control._formValues.team == 0) {
            //             loadRecruiters([], control._formValues.company, 0);
            //         } else if (control._formValues.company == 0 && control._formValues.team == 0) {
            //             loadRecruiters([], 0, 0);
            //         }
            //     }
            // }
            if (name === "team") {
                if (value.team && value.team != 0) {
                    loadSales([], [], value.team);
                    loadRecruiters([], [], value.team);
                } else {
                    if (control._formValues.company != 0 && control._formValues.branch != 0) {
                        loadRecruiters(control._formValues.branch, [], 0);
                    } else if (control._formValues.company == 0 && control._formValues.branch != 0) {
                        loadRecruiters(control._formValues.branch, [], 0);
                    } else if (control._formValues.company != 0 && control._formValues.branch == 0) {
                        loadRecruiters([], control._formValues.company, 0);
                    } else if (control._formValues.company == 0 && control._formValues.branch == 0) {
                        loadRecruiters([], [], 0);
                    }
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    // useEffect(() => {
    //     if (control._formValues.company === 0 && control._formValues.branch_Sales === 0 && control._formValues.branch_Recruiter === 0 && control._formValues.team === 0) {
    //         // loginObj.id === 1 ? loadSales(0,0,0) : setSales([]);
    //         loadSales([], 0, 0);
    //         loadRecruiters([], 0, 0);

    //     }
    //     if (control._formValues.company != 0 && control._formValues.branch_Sales != 0 && control._formValues.branch_Recruiter != 0 && control._formValues.team === 0) {
    //         loadSales(control._formValues.branch_Sales, 0, 0);
    //         loadRecruiters(control._formValues.branch_Recruiter, 0, 0);

    //     }
    //     if (control._formValues.company != 0 && control._formValues.branch_Sales === 0 && control._formValues.branch_Recruiter === 0 && control._formValues.team != 0) {
    //         loadSales([], 0, control._formValues.team);
    //         loadRecruiters([], 0, control._formValues.team);

    //     }
    //     if (control._formValues.company === 0 && control._formValues.branch_Sales != 0 && control._formValues.branch_Recruiter != 0 && control._formValues.team != 0) {
    //         // loadSales(control._formValues.branch,0,0);
    //         loadSales([], 0, control._formValues.team);
    //         loadRecruiters([], 0, control._formValues.team);

    //     }
    // }, [control._formValues.company, control._formValues.branch_Sales, control._formValues.branch_Recruiter, control._formValues.team]);

    useEffect(() => {
        if (selectedCompany.length === 0 && selectedBranch.length === 0) {
            loadBranches([]);
            loadTeam([], []);
            loadRecruiters([], [], 0);
            loadSales([], [], 0);
        }
        if (selectedCompany.length > 0 && selectedBranch.length === 0) {
            loadBranches(selectedCompany);
            loadTeam([], selectedCompany);
            loadRecruiters([], selectedCompany, 0);
            loadSales([], selectedCompany, 0);
        }
        if (selectedBranch.length > 0) {
            loadTeam(selectedBranch, []); // Assuming loadTeam takes a single branch
            loadRecruiters(selectedBranch, [], 0); // Pass the entire array
        }
        if (selectedSBranch.length > 0) {
            loadTeam(selectedBranch, []); // Assuming loadTeam takes a single branch
            loadSales(selectedSBranch, [], 0); // Pass the entire array
        }
    }, [selectedCompany, selectedBranch, selectedSBranch]);

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }

    const completeMethodEC = (event: { query: string }) => {
        loadClientCompanies(event.query);
    }


    // const onHide = () => {
    //     props.hideDialog();
    // }

    return (
        // <Dialog visible={props.open} style={{ width: '80vw' }} header="Search Requirement" modal className="p-fluid" onHide={onHide}>
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDate column={6} label="From Date" control={control} name="fromDate" />
            <JVDate column={6} label="To Date" control={control} name="toDate" />
            {!((_roles.includes(3) || _roles.includes(4) || _roles.includes(34) || _roles.includes(40))) && <JVDropdownInput column={6} label="Prime Vendor" completeMethod={completeMethodEC} control={control} name="vendor_Company" options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Prime Vendor" />}

            <JVInput column={6} label="Sub Vendor" control={control} name="subVendor" />
            <JVInput column={6} label="Req ID" type="number" control={control} name="req_ID" />
            {/* <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" /> */}
            <div className="field col-2 md:col-2">
                <p>Company</p>
                <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedCompany} onChange={(e) => setSelectedCompany(e.value)} options={companies} optionValue="company_ID" optionLabel="company_Name" display="chip" filter placeholder="Select Company" />
            </div>
            {/* <JVDropdown column={6} label="Branch Sales" control={control} name="branch_Sales" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Sales Branch" /> */}
            <div className="field col-2 md:col-2">
                <p>Recruiter Branch</p>
                <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedBranch} onChange={(e) => setSelectedBranch(e.value)} options={branches} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" />
            </div>
            <div className="field col-2 md:col-2">
                <p>Sales Branch</p>
                <MultiSelect className="" style={{ height: "37px", marginTop: "-10px" }} value={selectedSBranch} onChange={(e) => setSelectedSBranch(e.value)} options={branches} optionValue="branch_ID" optionLabel="branchName" display="chip" filter placeholder="Select Branches" />
            </div>
            {/* <JVDropdown column={6} label="Branch Recruiter" control={control} name="branch_Recruiter" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Recruiter Branch" /> */}
            {/* <JVDropdown column={6} label="Sales Manager" control={control} name="req_PostedBySalesManager" options={sales} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" /> */}
            {/* <JVDropdown column={6} label="Recruiter" control={control} name="req_SubmittedByRecruiter" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" /> */}
            <JVDropdown column={6} label="Team" control={control} name="team" options={team} optionLabel="team_Name" optionValue="team_ID" placeholder="Select Team" />
            <JVDropdown column={6} label="Req Category" control={control} name="req_Category" options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" placeholder="Select Req Category" />
            <JVDropdown column={6} label="Status" control={control} name="ECI_Type_Name" options={ecIStatus} optionLabel="ecI_Type_Name" optionValue="ecI_Type_Name" placeholder="Select Status" />
            <JVDropdown column={6} label="Sales Status" control={control} name="s_User_Status" options={sales_Status} optionLabel="label" optionValue="status" placeholder="Select sales Status" />
            <JVDropdown column={6} label="Recruiters Status" control={control} name="r_User_Status" options={recruiters_Status} optionLabel="label" optionValue="status" placeholder="Select Recruiters Status" />

            <div className="field col-12 md:col-2" >
                <label className="" style={{ display: 'block', marginBottom: '8px' }}>Sales Manager</label>
                <Dropdown value={selectedSm} onChange={(e) => {
                    console.log(e);
                    setselectedSm(e.value);
                    // loadSm(e.value?.Company,0,0);
                }} options={sales} optionLabel="user_Name" placeholder="Select Sales manager" optionValue="login_ID"
                    filter className="w-full" />

            </div>
            <div className="field col-12 md:col-2" >
                <label className="" style={{ display: 'block', marginBottom: '8px' }}>Recruiter</label>
                <Dropdown value={selectedRecruiter} onChange={(e) => {
                    setSelectedRecruiter(e.value);
                }} options={recruiters} optionLabel="user_Name" placeholder="Select Recruiter" optionValue="login_ID"
                    filter className="w-full" />

            </div>
            <JVInput column={6} label="Consultant Name/Email" type="text" control={control} name="Consultant_Name" />
            <JVDropdown column={6} label="Latency Type" control={control} name="litency_Type" options={LitencyType} optionLabel="litency_Type" optionValue="litency_Type" placeholder="Select Litency" />
            <JVDropdown column={6} label="Client Type" control={control} name="client_Type" options={client_Type} optionLabel="clientTypeName" optionValue="id" placeholder="Select Client Type" />

            <div style={{ margin: '10px 0', width: '100%' }}></div>

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyFilter); setselectedSm(null); setSelectedRecruiter(null); setSelectedBranch([]); setSelectedSBranch([]); setSelectedCompany([]); }} type="button"></Button>
            </div>
        </form>
    )
}
